import styled from "styled-components";
import Video from "../Video/Video";
import Image from "../Image/Image";

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Container = styled.div`
  height: 280px;
  display: flex;
  gap: 12px;
  position: relative;

  @media (max-width: 768px) {
    height: 220px;
  }
`;

export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 170px;
`;

export const RightContent = styled.div`
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

export const ArrowContainer = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-40%);
`;

export const StyledVideo = styled(Video)`
  height: 100%;
  width: unset;
  aspect-ratio: unset;
`;

export const StyledImage = styled(Image)`
  height: 100%;
  width: unset;
  aspect-ratio: unset;

  img {
    object-fit: cover;
  }
`;

export const RightContentOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 61.05%,
    rgba(0, 0, 0, 0.64) 100%
  );
`;

export const ModelName = styled.p`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.08px;
  position: absolute;
  bottom: 28px;
  width: 100%;
`;

export const Username = styled.p`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.06px;
  opacity: 0.7;
  position: absolute;
  bottom: 8px;
  width: 100%;
`;

export const UploadImageContainer = styled.div`
  height: 180px;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

export const UploadImageButton = styled.button`
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.37);
  backdrop-filter: blur(6.849999904632568px);
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translate(-50%);
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 32px;
  cursor: pointer;
`;

export const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 5px;
  padding: 6px;
  right: 5px;
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const NudifyText = styled.div`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: -0.065px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-left: 10px;
`;

export const GenerateContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const GenerateButton = styled.button`
  width: 130px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  color: #0f2c32;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: -0.08px;
  padding-inline: 8px;

  @media (max-width: 768px) {
    padding-inline: 4px;
    width: unset;
    flex: 1;
  }
`;

export const IconWrapper = styled.div`
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const InfoIconWrapper = styled(IconWrapper)``;

export const TooltipContainer = styled.div`
  border-radius: 16px;
  border: 1px solid #18181b;
  background: #09090a;
  padding: 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 350px;
  z-index: 100;

  @media (max-width: 768px) {
    width: 350px;
    left: -314px;
    top: 50px;
  }
`;

export const TooltipText = styled.p`
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
`;

export const GenerateContainerMobile = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: 768px) {
    display: none;
  }
`;
